module.exports = __webpack_public_path__ + "img/zhishu.7fbe0c72.svg";